var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSolar2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 34,
    viewBox: "0 0 30 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.66633 7.00004V2.00004C6.66633 1.07957 7.41253 0.333374 8.333 0.333374H28.333C29.2535 0.333374 29.9997 1.07957 29.9997 2.00004V25.3334C29.9997 26.2539 29.2535 27 28.333 27H23.333V31.9985C23.333 32.9199 22.5832 33.6667 21.655 33.6667H1.67777C0.750983 33.6667 0 32.9257 0 31.9985L0.00433326 8.66816C0.00449992 7.74689 0.7544 7.00004 1.68237 7.00004H6.66633ZM3.33737 10.3334L3.33365 30.3334H19.9997V10.3334H3.33737ZM9.99967 7.00004H23.333V23.6667H26.6663V3.66671H9.99967V7.00004ZM6.66667 15.3334H16.6667V18.6667H6.66667V15.3334ZM6.66667 22H16.6667V25.3334H6.66667V22Z",
    fill: "#0AC79A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSolar2);
export default __webpack_public_path__ + "static/media/solar2.ae5b0668cb196a55383a4db6b1abe073.svg";
export { ForwardRef as ReactComponent };